module.exports = __webpack_public_path__ + "static/media/2022.6235d964.csv";